import { ContextMenuItem } from 'types';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./context-menu.i18n.json'));

export function getContextMenuItems(
  saved: boolean,
  canEdit: boolean,
  onDelete: () => void,
  onDownload: () => void,
  onEdit: () => void
): Array<ContextMenuItem> {
  if (canEdit) {
    return [
      {
        name: 'download-all',
        text: __t('story_snippets_context_menu_utils.download_all'),
        onClick: onDownload,
        disabled: !saved
      },
      {
        name: 'delete-all',
        text: __t('story_snippets_context_menu_utils.delete_all'),
        onClick: onDelete
      }
    ];
  }

  return [
    {
      name: 'download-all',
      text: __t('story_snippets_context_menu_utils.download_all'),
      onClick: onDownload,
      disabled: !saved
    },
    {
      name: 'edit-content',
      text: __t('story_snippets_context_menu_utils.edit_content'),
      onClick: onEdit
    }
  ];
}
